
import "./internal.css";
import { useState, useEffect } from "react";

/* banco de dados */
import { db } from "../../services/firebaseConnection";
import { collection, doc, setDoc, addDoc, getDocs } from "firebase/firestore";

export default function Details() {
  
    useEffect(() => {
    // 1. Define a função global que o SDK chamará ao carregar
    window.fbAsyncInit = function() {
      window.FB.init({
        appId: '936860817533052',
        cookie: true,
        xfbml: true,
        version: 'v22.0'
      });
      console.log("✅ SDK do Facebook inicializado com sucesso!");
    };

    // 2. Garante que o script seja injetado apenas uma vez
    const id = 'facebook-jssdk';
    if (document.getElementById(id)) return;

    const js = document.createElement('script');
    js.id = id;
    js.src = "https://facebook.net";
    js.async = true;
    js.defer = true;
    js.onerror = () => {
      console.error("❌ Erro ao carregar o script da Meta. Verifique se há bloqueadores de anúncios ativos.");
    };

    document.body.appendChild(js);
  }, []);


const handleConnectWhatsApp = () => {
  const appId = '936860817533052'; 
  const configId = '230098829822941'; 
  
  // Use exatamente a URL que está no topo do seu navegador
  const redirectUri = "http://gptmaker.ai"; 

  const oauthUrl = `https://facebook.com?` +
    `client_id=${appId}` +
    `&config_id=${configId}` +
    `&response_type=code` +
    `&override_default_response_type=true` +
    `&redirect_uri=${encodeURIComponent(redirectUri)}` +
    `&scope=whatsapp_business_management,whatsapp_business_messaging`; // ADICIONE ISSO

  window.open(oauthUrl, 'facebook-login', 'width=600,height=700');
};






  const criar_plano = () => {};
  const migrarMedical = () => {};

  return(
      <div>
          <span>Para criar um plano</span>
          <br /><br />
          <div><button type="button" onClick={criar_plano}>Criar Plano</button></div>
          <br /><br />
          <span>Para criar uma agenda de testes</span>
          <br /><br />
          <div><button type="button" onClick={migrarMedical}>Dados</button></div>
          <br /><br />
          <div><button type="button" onClick={handleConnectWhatsApp}>Conectar WhatsApp</button></div>
      </div>
  )
}










    /*
    async function criar_plano(data) {
        try {
            let dt = new Date();

            const plandoc = await addDoc(collection(db, "plans"), { 
                codigo: "EST1",
                ramo: "Esteticistas",
                atendimento: "W",
                valor: 6,
                data_criacao: dt,
                data_inicio_vigencia: dt,
                data_termino_vigencia: new Date("2100-12-31T23:59:59Z"),
            });

        } catch (erro) {
            console.log(erro);
        }
    }


async function migrarMedical() {

    try {

        const snap = await getDocs(collection(db, "medical"));

        console.log("Documentos encontrados:", snap.size);

        for (const document of snap.docs) {

            const data = document.data();

            // cria na coleção nova
            await addDoc(collection(db, "medical"), data);

            // opcional: apagar da antiga
            // await deleteDoc(doc(db, "medical_", document.id));

            console.log("Migrado:", document.id);
        }

        console.log("Migração concluída!");

    } catch (error) {
        console.log("Erro na migração:", error);
    }

}
*/